// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "google_my_business_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "google_my_business_account" table (1:1 with a DB row, on the wire). */
export const googleMyBusinessAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    connectedById: z.string().nullable(),
    googleAccountEmail: z.string(),
    accountName: z.string(),
    locationId: z.string(),
    locationName: z.string(),
    placeId: z.string(),
    reviewLink: z.string(),
    averageRating: z.number().nullable(),
    totalReviews: z.number().nullable(),
    encryptedCredentials: z.string(),
    tokenExpiresAt: z.string().datetime().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=googleMyBusinessAccount.js.map